import { render, staticRenderFns } from "./JeeIcon.vue?vue&type=template&id=05580cb4&scoped=true&"
import script from "./JeeIcon.vue?vue&type=script&lang=js&"
export * from "./JeeIcon.vue?vue&type=script&lang=js&"
import style0 from "./JeeIcon.vue?vue&type=style&index=0&id=05580cb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05580cb4",
  null
  
)

export default component.exports